import { createCategoryHandler } from "../category-dispatcher";
import { actionTools } from "./action-tools";

/**
 * Category handler for extended action operations.
 * Consolidates action-tools sync handlers for forEach, MQTT subscribe,
 * and recurring action sub-collections.
 */
export const handleActionExtendedCategory = createCategoryHandler({
  add_to_for_each: actionTools.sync!.ui_logic_add_action_to_for_each,
  set_for_each_data: actionTools.sync!.ui_logic_set_action_for_each_data,
  reorder_for_each: actionTools.sync!.ui_logic_reorder_for_each_actions,
  add_to_mqtt: actionTools.sync!.ui_logic_add_action_to_mqtt_subscribe,
  set_mqtt_data: actionTools.sync!.ui_logic_set_action_mqtt_subscribe_data,
  reorder_mqtt: actionTools.sync!.ui_logic_reorder_mqtt_subscribe_actions,
  add_recurring: actionTools.sync!.ui_logic_add_action_recurring,
  remove_recurring: actionTools.sync!.ui_logic_remove_action_recurring,
  set_recurring_data: actionTools.sync!.ui_logic_set_action_recurring_actions_data,
  add_to_recurring: actionTools.sync!.ui_logic_add_action_to_recurring_actions,
  reorder_recurring: actionTools.sync!.ui_logic_reorder_recurring_actions
});
